import React, { useEffect } from "react";
import { ContentCardType } from "../../../controller/MasterController";
import { getStoreCouponTitle } from "../../../utils/util";
import { langState, langText } from "../../../recoil/lang";
import { useRecoilState } from "recoil";

interface StoreCouponProps {
  item: ContentCardType;
  navigateCoupon: any;
}

const StoreCouponContent = ({ item, navigateCoupon }: StoreCouponProps) => {
  const [lang, setLang] = useRecoilState<number>(langState);

  return (
    <div
      className="storeItem"
      onClick={() => navigateCoupon(item)}
    >
      <img className="titleImg" src={`${item.data.url}`} />
      <div className="itemContent">
        <p>{getStoreCouponTitle(item.data, lang)}</p>
      </div>
    </div>
  );
};
export default StoreCouponContent;
